import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-informe-unidades-cliente',
  templateUrl: './informe-unidades-cliente.component.html',
  styleUrls: ['./informe-unidades-cliente.component.css']
})
export class InformeUnidadesClienteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
